import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constants } from 'src/app/core/common';

import { SnackBarComponent } from '../component/snack-bar/snack-bar.component';
import { FeedbackModel, FeedbackType } from '../model';

@Injectable({
  providedIn: 'root',
})
export class AsyncFeedbackService {
  constructor(private snackBar: MatSnackBar) {}

  public showFeedback(feedback: FeedbackModel) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      // data
      data: {
        message: feedback.message,
        icon:
          feedback.type === FeedbackType.Success
            ? 'check_box'
            : feedback.type === FeedbackType.Failure
            ? 'error'
            : 'warning',
        url: feedback.url,
        urlText: feedback.urlText,
      },
      // duration
      duration: feedback.duration
        ? feedback.duration
        : Constants.SNACK_BAR_DEFAULT_DURATION,
      // panel class
      panelClass:
        feedback.type === FeedbackType.Failure
          ? ['snack-bar-error']
          : feedback.type === FeedbackType.Warning
          ? ['snack-bar-warring']
          : [],
    });
  }
}
